<template>
  <div class="main-feed mt-5">
    <div>
      <v-row class="mb-5">
            <v-spacer></v-spacer>
            <v-btn                    
                large
                v-on:click="registerLease"
                color="primary" dark
                width="175px"
                >+ Register new lease</v-btn>
      </v-row> 
      <v-row class="ma-0">
        <h2>Lease Registrations</h2>
        <v-spacer></v-spacer>
        <div class="text-center">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            offset-y
            :nudge-right="-10"
          >
            <template v-slot:activator="{ on, attrs }">
              <span class="mr-5" v-bind="attrs" v-on="on"
                ><font-awesome-icon icon="filter" /> FILTER
              </span>
            </template>
            <v-card>
              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox
                      v-model="statuses"
                      label="Request Created"
                      value="RequestCreated"
                    ></v-checkbox>
                  </v-list-item-action>
                </v-list-item>
                <v-divider light></v-divider>
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox
                      v-model="statuses"
                      label="Request Finalized"
                      value="RequestFinalized"
                    ></v-checkbox>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox
                      v-model="statuses"
                      label="Payment Rejected"
                      value="PaymentRejected"
                    ></v-checkbox>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox
                      v-model="statuses"
                      label="Payment Captured"
                      value="PaymentCaptured"
                    ></v-checkbox>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox
                      v-model="statuses"
                      label="Workflow Completed"
                      value="WorkflowCompleted"
                    ></v-checkbox>
                  </v-list-item-action>
                </v-list-item>
              </v-list>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="statuses = ['RequestCreated']">
                  Reset
                </v-btn>
                <v-btn color="primary" text @click="applyFilters">
                  Apply
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </div>
      </v-row>
    </div>
    <v-data-table 
      :loading="loading"
      :headers="headers"
      :options.sync="options"
      :items="paginatedResponse.data"
      :server-items-length="paginatedResponse.totalCount"
      :search="search"
      :footer-props="footerProps">
      <template v-slot:item.requestId="{ item }">
        <router-link :to="`/admin/registration/lease/${item.requestId}`" target="_blank">{{
          item.requestId
        }}</router-link>
      </template>
      <template v-slot:item.submittedAt="{ item }">
        <span>{{ $dateUtils.formatDateTime(new Date(item.submittedAt)) }}</span>
      </template>
      <template v-slot:item.requester="{ item }">
        <span>{{ item.requester.lastName }}, {{ item.requester.firstName }}</span>
      </template>
      <template v-slot:item.startDate="{ item }">
        <span>{{ $dateUtils.formatDate(new Date(item.startDate)) }}</span>
      </template>
      <template v-slot:item.endDate="{ item }">
        <span>{{ $dateUtils.formatDate(new Date(item.endDate)) }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

import { PaginationOptions, PaginatedResponse } from "@/types/Pagination";
import workflowService from '@/services/admin/workflowService';

export default Vue.extend({
  name: "LeaseRequestList",
  props: {
    readyToApproveOnly: String,
  },
  data: function () {
    return {
      loading: false,
      paginatedResponse: {} as PaginatedResponse<object>,
      menu: false,
      search: '',
      statuses: ["RequestCreated"],
      options: {} as PaginationOptions,
      headers: [
        { text: "#ID", align: "left", value: "requestId" },
        { text: "Submitted at", align: "left", value: "submittedAt" },
        { text: "Requester", align: "left", value: "requester", sortable: false },
        { text: "Status", align: "left", value: "status" },
        { text: "Dog Id", align: "left", value: "dogId" },
        { text: "Start date", align: "left", value: "startDate" },
        { text: "End date", align: "left", value: "endDate" },
      ],
      footerProps: { 'items-per-page-options': [10, 20, 30, 40, 50] }
    };
  },
  created: function () { this.loadList() },
  watch: {
    options: {
      handler() {
        this.loadList();
      },
      deep: true,
    }
  },
  methods: {
    applyFilters: function () {
      this.menu = false;
      this.loadList();
    },
    loadList: async function () {
      this.loading = true;
      const {
        page,
        itemsPerPage,
      } = this.options;

      const response = await workflowService.getLeaseRegistrationsList({
        ...this.options,
        page: (page ?? 1) - 1,
        itemsPerPage: itemsPerPage ?? 10
      }, this.$data.statuses);

      this.loading = false;
      this.paginatedResponse = response;
    },
    registerLease: function() {
      this.$router.push({path: '/admin/registration/leases/new'});
    },
  },
});
</script>
